<template>
  <b-card
    :title="item.groupName||'...'"
  >
    <b-tabs>
      <b-tab :title="$t('General')">
        <form-user-group
          :key="'usergroupform'"
          ref="user_group_form"
          v-model="item"
          @submit="success"
          @error="error"
        />
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="d-inline-block mr-1"
          @click="generalTabSubmit"
        >
          {{ $t('Save') }}
        </b-button>
      </b-tab>
      <b-tab
        :title="$t('Projects')"
      >
        <table-user-group-projects :group-id="Number($route.params.id)" />
      </b-tab>
      <b-tab
        :title="$t('Users')"
      >
        <table-user-group-users :group-id="Number($route.params.id)" />
      </b-tab>

    </b-tabs>

  </b-card>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'

import {
  BButton, BCard, BTabs, BTab,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import FormUserGroup from '@/layouts/components/forms/FormUserGroup.vue'
import TableUserGroupProjects from '@/layouts/components/TableUserGroupProjects.vue'
import TableUserGroupUsers from '@/layouts/components/TableUserGroupUsers.vue'

export default {
  components: {
    BCard,
    BButton,
    BTabs,
    BTab,
    FormUserGroup,
    TableUserGroupProjects,
    TableUserGroupUsers,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      item: {
        groupName: null,
      },
    }
  },
  created() {
    if (this.$route.params.id && this.$route.params.id > 0) {
      this.initDetail()
    }
  },
  methods: {
    error(msg) {
      this.inProgress = false
      this.$swal({
        icon: 'error',
        title: 'Error!',
        text: msg.indexOf('email_unique') > -1 ? this.$t('Email exists!') : msg,
        customClass: {
          confirmButton: 'btn btn-danger',
        },
      })
    },
    success() {
      this.$swal({
        icon: 'success',
        title: 'Saved!',
        text: 'Saved successfuly.',
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
    },
    generalTabSubmit() {
      this.$refs.user_group_form.validationForm()
    },
    initDetail() {
      useJwt.axiosIns.get(`usergroup/${this.$route.params.id}`)
        .then(response => {
          if (response.data) {
            this.item = response.data
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
  },
}
</script>
